import { render, staticRenderFns } from "./LoadingCompanyHeader.vue?vue&type=template&id=0fa53595&scoped=true"
import script from "./LoadingCompanyHeader.vue?vue&type=script&lang=js"
export * from "./LoadingCompanyHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa53595",
  null
  
)

export default component.exports